import { accountDateOfBirthFormatter } from './account-date-of-birth.formatter';
import { stringCollection } from './string-collection.formatter';
import { unixTimestapFormatter } from './unix-timestap.formatter';
import { variablesFormatter } from './variables.formatter';

export const cellsValueFormatters = {
  account_date_of_birth: accountDateOfBirthFormatter,
  event_time: unixTimestapFormatter,
  last_updated_at: unixTimestapFormatter,
  variables: variablesFormatter,
  scoring_variables: variablesFormatter,
  plugins_list: stringCollection,
  plugins_mime_types: stringCollection,
};
